import React from "react";
import styled from "styled-components";
import {FlexContainer, Page,PrimaryButton,ScrollableContainer} from "../../components/styled";
import { useEffect ,useState} from "react";
import { getInventory } from "../../service/main/api";
import { useNavigate } from "react-router-dom";
import CustomSelect from "../../components/shared/customSelect";
import NoDataImage from "../../assets/images/noData.png";
import Loader from "../../components/shared/loader";
import EnergyFleskImage from "../../assets/images/energyFlesk.png";
import {useUserContext} from "../../context/UserContext";

const Inventory = () => {
    const [inventory,setInventory] = useState([]);
    const [usedItems,setUsedItems] = useState([]);
    const [unsedItems,setUnusedItems] = useState([]);
    const [showUsed,setShowUsed] = useState(false);
    const {user,energyItems} = useUserContext();
    const [ isLoading,setIsLoading ] = useState(true);
    const [energyFleskCount,setEnergyFleskCount] = useState(0);
    const navigate = useNavigate();

    const getInventoryData = async () => {
        setIsLoading(true);
        const response = await getInventory();
        if (!response?.success) {
            setIsLoading(false);
            
            return;
        }
        let groupedUnusedItems = [];
        let groupedUsedItems = [];
        
        let items = response.data.filter(item => item.item);
        setInventory(items);
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            // console.log("Item",item);
            
            if(item.used){
                const existingItem = groupedUsedItems.find(i => i.item._id === item.item._id);
                if(!existingItem){
                    groupedUsedItems.push({
                        item:item.item,
                        count:1,
                        id:item._id,
                        used:true
                    });
                }else{
                    existingItem.count++;
                }
            }else{
                const existingItem = groupedUnusedItems.find(i => i.item._id === item.item._id);
                if(!existingItem){
                    groupedUnusedItems.push({
                        item:item.item,
                        count:1,
                        id:item._id,
                        used:false
                    });
                }else{
                    existingItem.count++;
                }
            }
            setUnusedItems(groupedUnusedItems);
            setUsedItems(groupedUsedItems);
        
        }
        //  console.log("Grouped Items",groupedItems);
        // if(!showUsed){
        //     groupedItems = groupedItems.filter(item => !item.used);
        // }
        // setInventory(groupedItems);
        setTimeout(() => {
            setIsLoading(false); 
        }, 1000);
    }
     useEffect(() => {
        let energyFleskId = energyItems.find(item => item.name === "Energy Flesk")?._id;
        console.log("Energy Flesk ID:", energyFleskId);
        const data = user.energyItems ? user.energyItems[energyFleskId] || 0 : 0;
        console.log("Energy Flesks:", data);
        setEnergyFleskCount(data);
     }, [user]);

   const onItemClick = (item) => {
    let realItem = inventory.find(i => i._id === item.id);
        if(item.used){
            return;
        }
        switch (realItem.itemType) {
            case "CardPack":
                navigate('/openPack', { state: { item:realItem } });           
                break;
            case "Ticket":            
            navigate('/game')
                break;
            case "Enhancer":            
            navigate('/cards')
                break;
            case "LotteryTicketItem":            
            navigate('/ballcano')
                break;
            default:
                break;
        }
    }
    useEffect(() => {
        getInventoryData();
    }
    , [showUsed]);
    if(isLoading){
        return (
            <Page>
                <Loader fullscreen="true" />
            </Page>
        )
    }
    return (
        <Page>
            <ScrollableContainer style={{position:"relative"}}>
            <FilterTab>
                <CustomSelect
                    options={[
                        {label:"Hide Used",value:false},
                        {label:"Show All",value:true}
                    ]}
                    value={showUsed}
                    onChange={(value)=>setShowUsed(value)}
                />
            </FilterTab>
            {inventory.length === 0 &&
            <FlexContainer style={{height:"100%"}}>
                 <img src={NoDataImage} alt="No Data" />
            </FlexContainer>

            }
            <GridContainer>
                 <GridItem>
                        <StyledImage src={EnergyFleskImage} alt={"Energy Flesk"} />
                        <PrimaryButton onClick={energyFleskCount > 0 ? () => navigate("/game") : null} style={{height:"32px",opacity:energyFleskCount > 0 ? 1 : 0.5}}>{"Use"}</PrimaryButton>
                        <Badge>{energyFleskCount}x</Badge>
                 </GridItem>
            {unsedItems.length > 0 && React.Children.toArray(unsedItems.map((item) => (
                    <GridItem>
                        <StyledImage src={item.item.imageUri} alt={item.item.name} />
                        <PrimaryButton onClick={()=>onItemClick(item)} style={{height:"32px",opacity:item.used ? 0.5 : 1}}>{item.used ? "Used" : "Use"}</PrimaryButton>
                        <Badge>{item.count}x</Badge>
                    </GridItem>
                )))}
                {showUsed && usedItems.length > 0 && React.Children.toArray(usedItems.map((item) => (
                    <GridItem>
                        <StyledImage src={item.item.imageUri} alt={item.item.name} />
                        <PrimaryButton onClick={()=>onItemClick(item)} style={{height:"32px",opacity:item.used ? 0.5 : 1}}>{item.used ? "Used" : "Use"}</PrimaryButton>
                        <Badge>{item.count}x</Badge>
                    </GridItem>
                )))}

            </GridContainer>
            </ScrollableContainer>
        </Page>
    );
};

const GridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 10px;
    /* height: 100%; */
    overflow-y: auto;
    padding-bottom: 34px;
    padding-top: 56px;
`
const GridItem = styled.div`
    background: #110B2680;
    padding: 20px;
    border-radius: 23px;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap:8px;
`
const StyledImage = styled.img`
    width: 100%;
`
const FilterTab = styled.div`
    display:flex;
    justify-content:space-between;
    align-items:center;
    gap:8px;
    padding:8px;
    border-radius: 12px;
    background-color:rgba(65, 65, 66, 0.18);
    backdrop-filter: blur(52.70000076293945px);
    -webkit-backdrop-filter: blur(52.70000076293945px);
    height: 48px;
    width: 100%;
    position: absolute;
    border-radius: 12px;
    margin-bottom: 8px;
    margin-top: 8px;
    z-index: 1;
`
const Badge = styled.div`
    position: absolute;
    top: 6px;
    right: 6px;
    background-color:rgb(234, 0, 255);
    color: #FFFFFF;
    border-radius: 50%;
    padding: 4px;
    font-size: 12px;
`
export default Inventory;